/*
 * Author: Harper Yan
 * File Created: Tuesday, 25-04-01 03:46 pm
 * Last Modified: Tuesday, 25-04-01 03:48 pm, by Harper Yan
 */

export { default as DeCardVisa } from './DeCardVisa';
